module.exports = __webpack_public_path__ + "/images/sphereco_background.png";